export const languageIcon = {
	en: '🌐',
}

export const MENU_BUTTON_FADE_TIME = 100
